import { Link } from '@/components/common/Link';
import { useState, useEffect, useRef } from "react";
export default function AGNewsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "#F5F4F2",
    padding: "0 40px 48px"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&family=Inter:wght@300;400;500;600&display=swap');
        .learn-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background-color: rgb(53, 53, 51);
          color: #ffffff;
          border-radius: 28px;
          border: 1px solid rgb(53, 53, 51);
          padding: 4px 4px 4px 12px;
          font-size: 14px;
          font-weight: 500;
          line-height: 21px;
          text-transform: uppercase;
          text-decoration: none;
          cursor: pointer;
          transition: background-color 0.15s ease, border-color 0.15s ease;
          font-family: 'Inter', sans-serif;
          margin-top: 32px;
        }
        .learn-more-btn:hover {
          background-color: rgb(75, 75, 73);
          border-color: rgb(75, 75, 73);
        }
        .learn-more-btn .arrow-circle {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .ag-news-badge {
          display: inline-block;
          background-color: #F73C4A;
          color: #ffffff;
          border-radius: 20px;
          padding: 2px 12px;
          font-size: 48px;
          font-weight: 400;
          line-height: 48px;
          text-transform: uppercase;
          font-family: 'Inter', sans-serif;
          vertical-align: baseline;
        }
      `}</style>
      
    </section>;
}